var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.modals, function (modal, idx) {
    return _c('v-dialog', {
      key: modal.id,
      attrs: {
        "value": idx == _vm.modals.length - 1,
        "persistent": modal.persistent,
        "scrollable": _vm.isDialogScrollable(modal),
        "max-width": _vm.getMaxWidth(modal),
        "content-class": _vm.getContentClass(modal),
        "width": _vm.getWidth(modal)
      },
      on: {
        "input": function input($event) {
          return _vm.onDialogInput($event, modal, idx);
        }
      }
    }, [_c('v-card', {
      staticClass: "pa-0 d-flex flex-column modal-dialog-card",
      "class": {
        'modal-dialog-card--fill': _vm.modalUsesFillHeight(modal),
        'modal-dialog-card--fixed': _vm.modalUsesFixedLayout(modal)
      }
    }, [_c(modal.component, {
      tag: "component",
      staticClass: "w-100 d-flex flex-column flex-grow-1 min-height-0 overflow-hidden",
      attrs: {
        "params": modal.params
      }
    })], 1)], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }